import React from "react";
import styles from "../Yalla/yalla.module.css";
import BannerV1 from "../../../components/Banners/Banner-v1/banner-v1";
import TextOnly from "../../../components/TextOnly/textOnly";
import ImageWithText from "../../../components/ImageWithText/ImageWithText";
import TextWithBg from "../../../components/TextWithBg/TextWithBg";
import Animations from "../../../components/Animations/animations";
import MetaTags from "../../../components/MetaTags";

const Yalla = () => {
  const image = { url: "assets/yalla-banner.webp", alt: "Yalla app" };

  const headingOneContent = {
    mainTitle: "Yalla",
    subTitle: "",
    highlightedText: ["Food &", "Grocery"],
    description: "Delivery to Rival the Giants",
  };

  const subText =
    "A complete food and grocery delivery solution in a modern and sleek package";

  const powerByContent = [
    {
      heading: "Yalla - Food & Grocery Delivery Platform",
    },
    {
      subText: `Yalla is an advanced delivery solution designed to merge food and grocery services within a single platform, crafted with precision by Ninjas Code on the Enatega framework. Yalla goes beyond traditional delivery apps by focusing on user accessibility for a specific region with regional payment options, setting itself up as a fresh new competitor in the market. Targeting both convenience and customization.
Through a collaborative development process, the Ninjas Code team transformed Yalla from a vision into a versatile app that meets the diverse needs of its market while integrating a seamless user interface and flexible features.`,
    },
  ];

  const aboutContent = [
    {
      aboutImage: { url: "assets/yalla-1.webp", alt: "Yalla App" },
      aboutTitle: {
        title: "Strong Focus on",
        highlightedTitle: "Core Functionalities",
      },
      aboutDescription: `Unlike conventional delivery apps, Yalla’s platform integrates food, grocery, and retail options. This allows users to order a wide range of items beyond meals, transforming it into a comprehensive delivery solution. Extensive backend modifications empowered vendors to manage and update inventories efficiently, enhancing the user experience by offering a dynamic range of products.`,
      flexReverse: "false",
    },
    {
      aboutImage: { url: "assets/yalla-2.webp", alt: "Yalla App" },
      aboutTitle: {
        title: "Advanced Features for",
        highlightedTitle: "Competitive Edge",
      },
      aboutDescription: `To position Yalla as a strong alternative to giants like Wolt and Haat, the app was equipped with features that enhance both functionality and user engagement. These include an interactive map for locating nearby vendors, customizable search filters, and personalized recommendations, which together create a highly responsive and user-centered experience.`,
      flexReverse: "true",
    },
    {
      aboutImage: { url: "assets/yalla-3.webp", alt: "Yalla App" },
      aboutTitle: {
        title: "Optimized Local",
        highlightedTitle: "Payment Integration",
      },
      aboutDescription: `Understanding the importance of regional payment methods, the Ninjas Code team integrated a versatile payment gateway that supports credit cards, mobile wallets, and cash on delivery. This setup meets local regulatory requirements and ensures that Yalla’s users can select payment options that fit their preferences, fostering a smoother, more accessible transaction process.`,
      flexReverse: "false",
    },
  ];
  
  const conclusionText = {heading: "The Results", description: `Yalla’s launch met with positive feedback, especially for its innovative dual food and grocery delivery functionality, user-friendly design, and local payment options. With a strong foundation, Yalla has established itself as a serious player in the delivery market, offering a compelling alternative to established competitors.
Looking ahead, Yalla’s roadmap includes scaling its delivery services, incorporating advanced features, and potentially expanding to new markets. As Yalla continues to grow, the Ninjas Code team remains committed to supporting its development and helping it lead in the dynamic world of food and grocery delivery.`};
  return (
    <div>

<MetaTags
     title="Yalla: Smart Online Delivery Platform for Food & Groceries"
     description="Yalla is a versatile feature-rich food and grocery delivery solution with unique features to help you succeed in the food delivery market. So, get it now!"
     />
      <BannerV1
        image={image}
        headingOne={headingOneContent}
        subText={subText}
      />
  
      <TextOnly content={powerByContent} />

      <section className={styles.aboutSec}>
        <div className={styles.container}>
        <Animations animationType="fadeInUp" threshold={0.2}>
          <h2>Building Yalla for the Future of Delivery
          </h2>

          <p className={styles.subText}>From the outset, Yalla emphasized accessibility, creating a user interface that supports both Arabic, Hebrew and English to accommodate its diverse user base. The development team ensured right-to-left compatibility, offering a culturally relevant experience while preserving a streamlined, intuitive design. This approach ensured Yalla would be user-friendly for a wide audience, regardless of language or regional background.</p>
          <ImageWithText
          aboutContent={aboutContent}
          />
        </Animations>
        </div>
      </section>
      <TextWithBg 
          content={conclusionText}
        /> 
    </div>
  );
};

export default Yalla;
